import { cart } from 'core';
import { Progress } from 'ui/components';

export const CartProgress = () => {
  const {
    data: { minOrderValueNum, minOrderValuePending, minOrderValuePendingNum },
  } = cart.hooks.useCart();
  const progressRemaining = minOrderValueNum - minOrderValuePendingNum;

  return (
    <Progress
      maxValue={minOrderValueNum}
      remainingValue={`Faltam ${minOrderValuePending} para atingir o pedido mínimo`}
      value={progressRemaining}
    />
  );
};
